import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/Button';
interface Person {
  name: string;
  rank: string;
  image: string;
}
export function BlackBeltClubPage() {
  // Masters data - populated with exact information
  const masters: Person[] = [{
    name: 'Master Michael Atchison',
    rank: '6th Dan Master Tang Soo Do · 1st Dan Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_78ccb1de1ef14b94bca7669d08a2a1d0~mv2.jpeg'
  }, {
    name: 'Master Mark Kanaar',
    rank: '5th Dan Master Tae Kwon Do · 3rd Dan Instructor Tang Soo Do · Purple Belt Brazilian Jiu-Jitsu',
    image: 'https://static.wixstatic.com/media/a09ac0_2de382b388f54533893cf9a7f204b6e4~mv2.jpg'
  }, {
    name: 'Master Cindy Gohsman',
    rank: '5th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_6df577785e8f42a0a17af28102e3bdf8~mv2.jpg'
  }, {
    name: 'Master Danny McInerney',
    rank: '5th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_31b3892484644b7292fa12c320a42ecf~mv2.jpg'
  }, {
    name: 'Master Daniel Foster',
    rank: '5th Dan Master Tang Soo Do',
    image: 'https://static.wixstatic.com/media/fcd869_3b809ebd4a3742aa8171ba6d0ebccdd1~mv2.png'
  }, {
    name: 'Master Eric Demers',
    rank: '4th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a09ac0_182f50891421491291c982a3cc8ec617~mv2.jpg'
  }];
  // Senior Instructors data - populated with exact information
  const seniorInstructors: Person[] = [{
    name: 'Master Federico Garcia',
    rank: '4th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_6bbb3d45822c44f2b7d30414e42c024c~mv2.jpg'
  }, {
    name: 'Master Jason Enos',
    rank: '4th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_8efdb96d9b05424fa94edbfebe41fc2e~mv2.jpg'
  }, {
    name: 'Master Mark McCallum',
    rank: '4th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_fc081e4c12ff4f8c82bb81321d4efe3d~mv2.jpg'
  }, {
    name: 'Master Paul Rocha',
    rank: '4th Dan Master',
    image: 'https://static.wixstatic.com/media/a88700_0c395665a23d4ed2bd69baf154ec3554~mv2.jpg'
  }, {
    name: 'Master Kira Gohsman',
    rank: '4th Dan Master Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/fcd869_72a6286ad5504735a7ab58368cb2c6a7~mv2.jpg'
  }, {
    name: 'Master Eric Reynolds',
    rank: '4th Dan Master Tae Kwon Do · 1st Dan Tang Soo Do',
    image: 'https://static.wixstatic.com/media/a09ac0_1487814f3afd405386a5fc6e08b77df7~mv2.jpg'
  }];
  // Black Belts data - populated with exact information
  const blackBelts: Person[] = [{
    name: 'Bob Wagner',
    rank: '3rd Dan Instructor Tae Kwon Do · 2nd Dan Karate',
    image: 'https://static.wixstatic.com/media/a88700_5960ff39c1e7411983b07304899efadb~mv2.png'
  }, {
    name: 'Chad Kilbourn',
    rank: '3rd Dan Instructor Tae Kwon Do · 2nd Dan Instructor Tang Soo Do',
    image: 'https://static.wixstatic.com/media/a88700_56cb76f81ff242f7a4bb52f2d15dc47c~mv2.jpeg'
  }, {
    name: 'Joey Skutt',
    rank: '3rd Dan Instructor Tae Kwon Do · 2nd Dan Instructor Tang Soo Do · 2nd Dan Instructor ITF',
    image: 'https://static.wixstatic.com/media/a09ac0_6b17c556bf3e4197a06f1a52b9092831~mv2.jpg'
  }, {
    name: 'AJ Bostwick',
    rank: '3rd Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a09ac0_848dfdc7d451470b98b17615e6234c76~mv2.jpg'
  }, {
    name: 'Tyric Schwinn',
    rank: '3rd Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a09ac0_9706e1907c6c4b0caa36c20994d985a4~mv2.jpg'
  }, {
    name: 'Daymoon Hobi-Evans',
    rank: '3rd Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_b6a4a17bd0df43db8eeb3e0a7afdc76e~mv2.jpg'
  }, {
    name: 'Felix Pachacco',
    rank: '3rd Dan Instructor Black Belt',
    image: 'https://static.wixstatic.com/media/a88700_aeb66ec7e09e4c7a969dee53ca784fbf~mv2.jpg'
  }, {
    name: 'Roxy Kilbourn',
    rank: '3rd Dan Instructor Tae Kwon Do · 2nd Dan Tang Soo Do',
    image: 'https://static.wixstatic.com/media/a88700_39c82ccceccf4f0aa37a7864f0cf6726~mv2.jpeg'
  }, {
    name: 'Gabriella Orme',
    rank: '3rd Dan Tang Soo Do · 2nd Dan Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_4be0d88aab364ac98e3d5c484026d2f3~mv2.jpg'
  }, {
    name: 'Bill McCrumb',
    rank: '2nd Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_930257104f294584925b91d8d44d859c~mv2.jpg'
  }, {
    name: 'Keira Caldwell',
    rank: '2nd Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_89ff7e94c2ee403e896914a63afa488f~mv2.jpg'
  }, {
    name: 'Dylan Decker',
    rank: '1st Dan Assistant Instructor',
    image: 'https://static.wixstatic.com/media/a88700_a5ba1ccb609f44d884fe98567be33c5c~mv2.jpg'
  }, {
    name: 'Alex Fisk',
    rank: '1st Dan Assistant Instructor',
    image: 'https://static.wixstatic.com/media/a88700_461404371cdd4ef885774e2bbeca7863~mv2.jpg'
  }, {
    name: 'John Mayhew',
    rank: '1st Dan Assistant Instructor',
    image: 'https://static.wixstatic.com/media/a88700_4af9f683190c4c00a2546285df7a811e~mv2.jpg'
  }, {
    name: 'Juan Rodrigo',
    rank: '1st Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_f1a14fa3ff224f3aafed0ca6f47cdd47~mv2.jpg'
  }, {
    name: 'Tiffany Mayhew',
    rank: '1st Dan Instructor Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/fcd869_1e7bb9960a3e4e678807d51415dfc4bb~mv2.jpg'
  }];
  // Poom Black Belts data - populated with exact information
  const poomBlackBelts: Person[] = [{
    name: 'Micah Schramm',
    rank: '3rd Poom Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/a88700_df3221e980084fa286a156ecc41122cf~mv2.jpg'
  }, {
    name: 'Audrey Butzin',
    rank: '3rd Poom Black Belt',
    image: 'https://static.wixstatic.com/media/a88700_326f90ce043f43b1a3712ac97456e315~mv2.jpeg'
  }, {
    name: 'Sheila Chaddah',
    rank: '2nd Dan Tae Kwon Do',
    image: 'https://static.wixstatic.com/media/fcd869_24216ad361aa46d98418833b874c6011~mv2.jpg'
  }];
  const PersonCard = ({
    person
  }: {
    person: Person;
  }) => <div className="bg-white border border-slate-200 rounded-lg overflow-hidden shadow-sm" data-id="element-826">
      <div className="aspect-[3/4] bg-slate-100" data-id="element-827">
        <img src={person.image} alt={person.name} className="w-full h-full object-cover" data-id="element-828" />
      </div>
      <div className="p-4 text-center" data-id="element-829">
        <h3 className="text-lg font-bold text-[#1a2332] mb-1" data-id="element-830">{person.name}</h3>
        <p className="text-sm text-slate-600" data-id="element-831">{person.rank}</p>
      </div>
    </div>;
  const Section = ({
    title,
    people
  }: {
    title: string;
    people: Person[];
  }) => <section className="py-12" data-id="element-832">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-833">
        <h2 className="text-3xl font-bold text-[#1a2332] mb-8" data-id="element-834">{title}</h2>
        {people.length > 0 ? <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-835">
            {people.map((person, index) => <PersonCard key={index} person={person} data-id="element-836" />)}
          </div> : <p className="text-slate-500 italic" data-id="element-837">Content will be added soon.</p>}
      </div>
    </section>;
  return <div className="min-h-screen bg-white font-sans text-slate-900" data-id="element-838">
      <Header data-id="element-839" />

      <main className="pt-20" data-id="element-840">
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-slate-900 to-slate-800 text-white py-20" data-id="element-841">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-842">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-843">
              Che Ko Taekwondo Black Belt Club
            </h1>
            <p className="text-lg text-slate-200 max-w-3xl" data-id="element-844">
              The Che Ko Taekwondo Black Belt Club recognizes the dedication,
              discipline, and achievement of our Masters, Instructors, Black
              Belts, and Poom Black Belts. This page honors those who have
              committed years of training and testing while upholding the values
              of respect, perseverance, and leadership.
            </p>
          </div>
        </section>

        {/* Masters Section */}
        <Section title="Masters" people={masters} data-id="element-845" />

        {/* Senior Instructors Section */}
        <Section title="Senior Instructors" people={seniorInstructors} data-id="element-846" />

        {/* Black Belts Section */}
        <Section title="Black Belts" people={blackBelts} data-id="element-847" />

        {/* Poom Black Belts Section */}
        <Section title="Poom Black Belts" people={poomBlackBelts} data-id="element-848" />

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white" data-id="element-849">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-850">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-851">
              Begin Your Journey
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto" data-id="element-852">
              Every black belt began as a beginner. Whether your goal is
              confidence, discipline, competition, or personal growth, Che Ko
              Martial Arts provides a structured path forward for kids, teens,
              and adults across Mid-Michigan.
            </p>
            <Link to="/contact" data-id="element-853">
              <Button variant="secondary" size="lg" className="text-lg shadow-xl" data-id="element-854">
                Get Started Today
              </Button>
            </Link>
          </div>
        </section>
      </main>

      <Footer data-id="element-855" />
    </div>;
}